export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/readImages.worker.c954d67f.worker.js");
}
